export const TIME_FORMAT = 'HH:mm:ss';
export const DATE_FORMAT = 'DD/MM';
export const ORDERBOOK_DATE_TIME_FORMAT = 'DD MMM YYYY, HH:mm:ss:SSS';

export const NUMBER_OF_ORDERBOOK_PAGES = 1;
export const FETCH_DATA_MARGIN = 5;
